export default [
  {
    path: "school/away/teacher/assignment",
    name: "teacherAwayAssignment",
    component: () =>
      import(
        "../../../../components/management/away/assignment/teacher/TeacherIndividualAwayAssignmentPage"
      ),
  },
];
